import Icon from 'flarum/common/components/Icon';
const icons = {
  eur: m(Icon, {
    name: "fas fa-euro-sign"
  }),
  usd: m(Icon, {
    name: "fas fa-dollar-sign"
  }),
  yen: m(Icon, {
    name: "fas fa-yen-sign"
  }),
  gbp: m(Icon, {
    name: "fas fa-pound-sign"
  }),
  inr: m(Icon, {
    name: "fas fa-rupee-sign"
  }),
  aud: m(Icon, {
    name: "fas fa-dollar-sign"
  }),
  cad: m(Icon, {
    name: "fas fa-dollar-sign"
  }),
  cny: m(Icon, {
    name: "fas fa-yen-sign"
  }),
  nzd: m(Icon, {
    name: "fas fa-dollar-sign"
  }),
  rub: m(Icon, {
    name: "fas fa-ruble-sign"
  }),
  sgd: m(Icon, {
    name: "fas fa-dollar-sign"
  }),
  zar: m(Icon, {
    name: "fas fa-dollar-sign"
  })
};
export default function currencySymbol(code) {
  return code ? icons[code] ?? new Intl.NumberFormat('en-EN', {
    style: 'currency',
    currency: code
  }).format(0).replace('0.00', '') : '';
}
flarum.reg.add('floxum-payments', 'common/currencySymbol', currencySymbol);